import { Injectable } from '@angular/core';
import { ApiConfig} from '../_helpers/api-config'
import { AppSettings } from '../_helpers/app.settings';
import { Request } from '../_helpers/request';
import { HttpService } from '../shared/http.service';

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {

  constructor(private http: HttpService) { }

  deleteUtility(param: any) {
    let req: Request = {
      method: AppSettings.HTTP_METHODS.DELETE,
      url: `${ApiConfig.deleteUtility}${param.data.id}`,
      // queryString: param.data,
      success: param.success ? param.success : null,
      error: param.error ? param.error : null
    }
    this.http.sendRequest(req);
  }
  fetchAllUtilities(param: any) {
    let req: Request = {
      method: AppSettings.HTTP_METHODS.GET,
      url: `${ApiConfig.fetchAllUtilities}`,
      reqBody: param.data,
      success: param.success ? param.success : null,
      error: param.error ? param.error : null
    }
    this.http.sendRequest(req);
  }
  fetchUtilities(param: any) {
    let req: Request = {
      method: AppSettings.HTTP_METHODS.POST,
      url: `${ApiConfig.fetchUtilities}`,
      reqBody: param.data,
      success: param.success ? param.success : null,
      error: param.error ? param.error : null
    }
    this.http.sendRequest(req);
  }
  createUtility(param: any) {
    let req: Request = {
        method: AppSettings.HTTP_METHODS.POST,
        url: `${ApiConfig.createUtility}`,
        reqBody: param.data,
        success: param.success ? param.success : null,
        error: param.error ? param.error : null
      }
      this.http.sendRequest(req);
  }
  editUtility(param: any) {
    let req: Request = {
      method: AppSettings.HTTP_METHODS.POST,
      url: `${ApiConfig.editUtility}`,
      reqBody: param.data,
      success: param.success ? param.success : null,
      error: param.error ? param.error : null
    }
    this.http.sendRequest(req);
  }
}
